import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/basic-layout';
var meta = {};
var pre = 'dashboard-';
export default {
  path: '/',
  name: '_index',
  redirect: {
    name: "index"
  },
  meta: meta,
  component: BasicLayout,
  children: [{
    path: '/index',
    name: "index",
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '首页',
      icon: 'md-speedometer',
      closable: false,
      hidden: true
    }),
    component: function component() {
      return import('@/sys-pages/dashboard/console');
    }
  }]
};